export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        cycles: action.cycles,
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
